import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const LoginModal = ({ onClose, onLogin }) => {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch("https://7efu8nno5m.execute-api.us-west-1.amazonaws.com/dev/loginUser", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ identifier, password }),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.error || "Login failed");

      const userData = {
        email: data.email,
        username: data.username,
        conditions: data.conditions || [],
      };

      localStorage.setItem("user", JSON.stringify(userData));
      onLogin(userData);
      onClose();
      navigate("/");
      window.location.reload(); 
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="summary-modal">
      <div className="modal-content" style={{ maxWidth: "400px", position: "relative" }}>
        <button className="close-button" onClick={onClose}>×</button>
        <h2 className="login-modal-title">Log In</h2>
        <form onSubmit={handleLogin} style={{ display: "flex", flexDirection: "column", gap: "1rem", alignItems: "center" }}>
          <input
            type="text"
            placeholder="Email or Username"
            className="search-input"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            className="search-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="submit"
            className="summary-button"
            style={{ width: "100%", maxWidth: "320px" }}
          >
            Login
          </button>

          {error && <p style={{ color: "red" }}>{error}</p>}
        </form>
        <p style={{ textAlign: "center", marginTop: "1rem" }}>
          Don’t have an account?{" "}
          <span
            style={{ color: "#0077cc", cursor: "pointer" }}
            onClick={() => {
              onClose();
              navigate("/register");
            }}
          >
            Create one
          </span>
        </p>
      </div>
    </div>
  );
};

export default LoginModal;
